import axios from 'axios'
import {
  getFeedbackRequest,
  getFeedbackSuccess,
  getFeedbackFail,
  updateFeedbackStatusRequest,
  updateFeedbackStatusSuccess,
  updateFeedbackStatusFail,
  patchFeedbackRequest,
  patchFeedbackSuccess,
  patchFeedbackFail,
} from '../../../state/redux/slices/feedbackSlice.js'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 30000,
})

export const createFeedback = feedbackData => {
  const token = localStorage.getItem('authToken')
  return api.post('/v1/feedback', feedbackData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const getFeedback = feedbackId => async dispatch => {
  try {
    dispatch(getFeedbackRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.get(`/v1/feedback/${feedbackId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
    // Fix: Access the correct path based on your API structure
    dispatch(getFeedbackSuccess(response.data.data?.feedback || response.data.feedback))
  } catch (error) {
    dispatch(getFeedbackFail(error.response?.data?.message || error.message))
  }
}

export const getAllFeedback = () => async dispatch => {
  try {
    dispatch(getFeedbackRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.get('/v1/feedback/admin/all', {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
    
    // Fix: Access the correct nested path for feedback array
    console.log('API Response:', response.data) // Debug log
    dispatch(getFeedbackSuccess(response.data.data.feedback))
  } catch (error) {
    console.error('getAllFeedback error:', error) // Debug log
    dispatch(getFeedbackFail(error.response?.data?.message || error.message))
  }
}

export const updateFeedback = (feedbackId, updatedData) => async dispatch => {
  try {
    dispatch(patchFeedbackRequest())
    const token = localStorage.getItem('authToken')

    const response = await api.put(`/v1/feedback/admin/${feedbackId}`, updatedData, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })

    // Fix: Access the correct path based on your API structure
    const updatedFeedback = response.data.data?.feedback || response.data.feedback
    dispatch(patchFeedbackSuccess(updatedFeedback))
    return updatedFeedback
  } catch (error) {
    dispatch(patchFeedbackFail(error.response?.data?.message || error.message))
  }
}

export const getFeedbackAnalytics = () => {
  const token = localStorage.getItem('authToken')
  return api.get('/v1/feedback/admin/analytics', {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const updateFeedbackStatus = (feedbackId, status) => async dispatch => {
  try {
    dispatch(updateFeedbackStatusRequest())
    const token = localStorage.getItem('authToken')

    const response = await api.patch(
      `/v1/feedback/admin/${feedbackId}/status`,
      { status },
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    )

    // Fix: Access the correct path based on your API structure
    dispatch(updateFeedbackStatusSuccess(response.data.data?.feedback || response.data.feedback))
    return response.data.data?.feedback || response.data.feedback
  } catch (error) {
    dispatch(updateFeedbackStatusFail(error.response?.data?.message || error.message))
    throw error
  }
}

export const markFeedbackOpened = feedbackId => async dispatch => {
  try {
    dispatch(updateFeedbackStatusRequest())
    const token = localStorage.getItem('authToken')

    const response = await api.patch(`/v1/feedback/${feedbackId}/opened`, {}, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })

    // Fix: Access the correct path based on your API structure
    dispatch(updateFeedbackStatusSuccess(response.data.data?.feedback || response.data.feedback))
    return response.data.data?.feedback || response.data.feedback
  } catch (error) {
    dispatch(updateFeedbackStatusFail(error.response?.data?.message || error.message))
    throw error
  }
}

// New API functions for forward, reply, and unread
export const forwardFeedback = (feedbackId, forwardData) => {
  const token = localStorage.getItem('authToken')
  return api.post(`/v1/feedback/${feedbackId}/forward`, forwardData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const replyToFeedback = (feedbackId, replyData) => {
  const token = localStorage.getItem('authToken')
  return api.post(`/v1/feedback/${feedbackId}/reply`, replyData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const markFeedbackUnread = feedbackId => {
  const token = localStorage.getItem('authToken')
  return api.patch(`/v1/feedback/${feedbackId}/unread`, {}, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}